/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const questionWithScoreDataSubtypeSchema = z.enum(['name', 'email', 'phone', 'multiple'])

export type QuestionWithScoreDataSubtypeSchema = z.infer<typeof questionWithScoreDataSubtypeSchema>
